module.exports = "img/room_replaced.80042bb.svg";